import { Typography, Grid } from "@mui/material";
import AurIcon, {IconColors, IconNames} from "../aur-icon/AurIcon";
import {t} from 'i18next';

const AurSysAdminLabel = () => {
    return (
        <div>
      <div className="sys-admin-label">
        <Grid container spacing={1}>
          <Grid item>
          <AurIcon
            icon={IconNames.Security}
            color={IconColors.Primary}
            size={'medium'}
          />
          </Grid>
          <Grid item>
          <Typography
            className="typo-text subhead4_size mist-100"
          >
            {t('UserProfile.roleLabel')}
          </Typography>
          </Grid>
          <Grid item>
          <Typography
            className="typo-text body2_size mist-400"
          >
            {t('UserProfile.sysAdminLabel')}
          </Typography>
          </Grid>
          </Grid>
        <div
          className='sys-admin-note'
        >
          <Typography variant="body1">
            {t('UserProfile.userProfileNoteLabel')}
          </Typography>
        </div>
      </div>
      {/*admin role logic*/}
    </div>
    )
}

export default AurSysAdminLabel;